export var ZIndex;
(function (ZIndex) {
    ZIndex[ZIndex["FilterCallout"] = 3] = "FilterCallout";
})(ZIndex || (ZIndex = {}));
